module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/en_1-eeda80a8139d9e66e950741677aea483.jpg";